"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAriaHider = void 0;
function createAriaHider(containerNode, selector) {
    if (selector === void 0) { selector = 'body > :not(script)'; }
    var rootNodes = Array.from(document.querySelectorAll(selector)).map(function (node) {
        if (node.contains(containerNode)) {
            return undefined;
        }
        var ariaHidden = node.getAttribute('aria-hidden');
        if (ariaHidden === null || ariaHidden === 'false') {
            node.setAttribute('aria-hidden', 'true');
        }
        return { node: node, ariaHidden: ariaHidden };
    });
    return function () {
        rootNodes.forEach(function (item) {
            if (!item) {
                return;
            }
            if (item.ariaHidden === null) {
                item.node.removeAttribute('aria-hidden');
            }
            else {
                item.node.setAttribute('aria-hidden', item.ariaHidden);
            }
        });
    };
}
exports.createAriaHider = createAriaHider;
